exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-actions[data-v-6a8b8a42]{display:inline-block;margin-left:10px}.actions[data-v-6a8b8a42],.footer[data-v-6a8b8a42]{margin-top:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a8b8a42","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Account/AccountAddress.vue
// module id = epxj
// module chunks = 0